import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { akEditorDefaultLayoutWidth, VIEWPORT_SIZES } from '@atlaskit/editor-shared-styles/consts';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { pluginKey } from './plugin-key';
export function createPlugin(dispatch) {
  return new SafePlugin({
    key: pluginKey,
    state: {
      init: function init() {
        if (editorExperiment('platform_editor_stop_width_reflows', true)) {
          return {
            // Optimise for default laptop MDPI width - this will update with the resize observer
            width: VIEWPORT_SIZES.laptopMDPI.width,
            // Use the default width - if full width or small it will update with resize observer
            lineLength: akEditorDefaultLayoutWidth
          };
        } else {
          return {
            width: document.body.offsetWidth
          };
        }
      },
      // @ts-ignore - Workaround for help-center local consumption
      apply: function apply(tr, pluginState) {
        var _meta$width, _meta$lineLength;
        var meta = tr.getMeta(pluginKey);
        if (!meta) {
          return pluginState;
        }
        var newPluginState = editorExperiment('platform_editor_stop_width_reflows', true) ? {
          width: (_meta$width = meta.width) !== null && _meta$width !== void 0 ? _meta$width : pluginState === null || pluginState === void 0 ? void 0 : pluginState.width,
          lineLength: (_meta$lineLength = meta.lineLength) !== null && _meta$lineLength !== void 0 ? _meta$lineLength : pluginState === null || pluginState === void 0 ? void 0 : pluginState.lineLength
        } : _objectSpread(_objectSpread({}, pluginState), meta);
        if (newPluginState && (pluginState.width !== newPluginState.width || pluginState.lineLength !== newPluginState.lineLength)) {
          dispatch(pluginKey, newPluginState);
          return newPluginState;
        }
        return pluginState;
      }
    }
  });
}